export const DEV_ENV_HOST_NAME: string = 'datapipeline-dev.pdd.ihs.com';
export const DEV_ENV_API_ROOT: string = 'http://localhost:50743';
export const TEST_ENV_HOST_NAME: string = 'datapipeline-test.pdd.ihs.com';
export const TEST_ENV_API_ROOT: string = 'https://pdd-datapipeline-t-ws.pdd.ihs.com';
export const PROD_ENV_HOST_NAME: string = 'datapipeline.pdd.ihs.com';
export const PROD_ENV_API_ROOT: string = 'https://pdd-datapipeline-p-ws.pdd.ihs.com';
export const STORAGE_AUTH_ITEM_NAME: string = 'Authorization';
export const STORAGE_USERID_ITEM_NAME: string = 'UserId';
